import ProductSaga from "./saga";
import productOperationSaga from "./product-operations.saga";

export default [ProductSaga, productOperationSaga];
